/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Toevoegen"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Alles verwijderen"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var nlNL = Object.assign(TranslationProviderComponent, {
  translations
});

export { nlNL as n };
//# sourceMappingURL=nl-NL-D01PDT6h.js.map
